var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { vueLinkLocalStorage } from "../../../lib/utils/vue";
import { LayoutPanel, TimelinePanel, WindowPortal } from './components';
import OptionButtons from './util/OptionButtons';
import devToolMixin from './util/devToolMixin';
import captureIcon from "../../../lib/assets/captureIcon.svg";
let DevTool = class DevTool extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.lastEventId = null;
  }
  created() {
    vueLinkLocalStorage(this, 'UcDevTool', 'dataSourceDrawerOpen');
    vueLinkLocalStorage(this, 'UcDevTool', 'windowOptions');
    this.bus.devTool = this;
  }
  get componentIds() {
    var _this$uc$renderer;
    return Object.keys(((_this$uc$renderer = this.uc.renderer) === null || _this$uc$renderer === void 0 ? void 0 : _this$uc$renderer.compProps) || []);
  }
  activeCompinfoHandler() {
    var _this$uc;
    if (this.designer) {
      if (this.designer.compPath === this.bus.activeCompInfo.compPath) return;
      this.$set(this.designer, 'compPath', this.bus.activeCompInfo.compPath);
    }
    (_this$uc = this.uc) === null || _this$uc === void 0 || _this$uc.notifyPageletsChange(0);
  }
  pathChangeHandler(val) {
    if (val instanceof String) this.activeCompPath = val;
  }
  devToolTabKeyHandler(val) {
    var _this$events;
    if (val === 'timeline' && !this.manualDisable) {
      this.$set(this.bus.options, 'recording', true);
    } else {
      // this.$set(this.bus.options, 'recording', false);
    }
    this.lastEventId = (_this$events = this.events[this.events.length - 1]) === null || _this$events === void 0 ? void 0 : _this$events.eid;
  }
  render() {
    const h = arguments[0];
    return h(WindowPortal, [h("div", {
      "class": "ucd-capturing",
      "style": {
        display: this.bus.options.capturing ? 'flex' : 'none'
      }
    }, [h("img", {
      "attrs": {
        "src": captureIcon
      }
    }), h("a-button", {
      "on": {
        "click": () => this.bus.options.capturing = false
      }
    }, ["\u53D6\u6D88\u6355\u83B7"])]), h("a-tabs", {
      "style": {
        height: '100%'
      },
      "attrs": {
        "data-ucd-report-mod": "devtool"
      },
      "model": {
        value: this.devToolTabKey,
        callback: $$v => {
          this.devToolTabKey = $$v;
        }
      }
    }, [h("a-tab-pane", {
      "key": "layout"
    }, [h("span", {
      "slot": "tab",
      "attrs": {
        "data-ucd-report-eid": "layout",
        "data-uc-report-mod": "devtool"
      }
    }, [" \u5E03\u5C40 "]), h(LayoutPanel, {
      "attrs": {
        "data-ucd-report-submodes": "布局"
      }
    })]), h("a-tab-pane", {
      "key": "timeline"
    }, [h("span", {
      "slot": "tab",
      "attrs": {
        "data-ucd-report-eid": "timeline",
        "data-uc-report-mod": "devtool"
      }
    }, [this.bus.options.recording ? h("a-icon", {
      "attrs": {
        "type": "video-camera",
        "theme": "twoTone",
        "twoToneColor": this.bus.options.recording ? 'red' : 'gray'
      }
    }) : null, this.events.length && this.lastEventId && this.events[this.events.length - 1].eid !== this.lastEventId ? h("a-badge", {
      "attrs": {
        "dot": true
      }
    }, ["Timeline"]) : h("span", [" Timeline "])]), h(TimelinePanel)]), Object.keys(this.extensionPanels || {}).map(panelKey => {
      const Component = this.extensionPanels[panelKey].component;
      return h("a-tab-pane", {
        "key": panelKey
      }, [h("span", {
        "slot": 'tab',
        "attrs": {
          "data-ucd-report-eid": this.extensionPanels[panelKey].name,
          "data-uc-report-mod": "devtool"
        }
      }, [this.extensionPanels[panelKey].name]), h(Component, {
        "attrs": {
          "uc": this.uc
        }
      })]);
    }), this.displayMode !== 'seperate' && h("div", {
      "slot": "tabBarExtraContent",
      "style": {
        display: 'flex',
        height: '47px',
        alignItems: 'center'
      }
    }, [h(OptionButtons), h("a-button", {
      "attrs": {
        "icon": "close",
        "type": "link"
      },
      "class": "ucd-devTool-close",
      "on": {
        "click": () => this.$set(this.bus.options, 'open', false)
      }
    })])])]);
  }
};
__decorate([Watch('bus.activeCompInfo', {
  deep: true
})], DevTool.prototype, "activeCompinfoHandler", null);
__decorate([Watch('designerCompPath')], DevTool.prototype, "pathChangeHandler", null);
__decorate([Watch('bus.devToolTabKey')], DevTool.prototype, "devToolTabKeyHandler", null);
DevTool = __decorate([Component({
  name: 'DevTool',
  components: {
    LayoutPanel
  }
})], DevTool);
export default DevTool;
//# sourceMappingURL=index.js.map
